import { configureStore, EnhancedStore } from '@reduxjs/toolkit';
import * as Sentry from '@sentry/browser';
import createSagaMiddleware from 'redux-saga';
import createSentryMiddleware from 'redux-sentry-middleware';

import config from '../config';
import reducer from '../reducers';
import sagas from '../sagas';

const initialState = (): EnhancedStore => {
    const sagaMiddleware = createSagaMiddleware();
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const sentryMiddleware = createSentryMiddleware(Sentry, {});

    const middlewares = [sagaMiddleware, sentryMiddleware];

    if (config.env === 'PROD') {
        Sentry.init({
            dsn: 'https://95c2d87a78fe4597bb4a3ec5f6071707@sentry.io/1507048',
            integrations: [new Sentry.Integrations.Breadcrumbs({ console: false })],
            release: process.env.REACT_APP_RELEASE_VERSION,
            environment: config.env,
        });
    }

    const store = configureStore({
        reducer,
        devTools: config.env !== 'PROD',
        middleware: getDefaultMiddleware => getDefaultMiddleware().concat(middlewares),
    });

    sagaMiddleware.run(sagas);
    //  if (customSagas) sagaMiddleware.run(customSagas);

    return store;
};

export default initialState;
